"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WaitTypes = void 0;
var WaitTypes;
exports.WaitTypes = WaitTypes;
(function (WaitTypes) {
  WaitTypes["Reject"] = "REJECT";
  WaitTypes["Resolve"] = "Reolve";
})(WaitTypes || (exports.WaitTypes = WaitTypes = {}));
var wait = function wait(time, type) {
  if (type === void 0) {
    type = WaitTypes.Resolve;
  }
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      switch (type) {
        case WaitTypes.Reject:
          reject({
            error: 'timeout'
          });
          break;
        case WaitTypes.Resolve:
        default:
          resolve(undefined);
      }
    }, time);
  });
};
var _default = wait;
exports.default = _default;